import { useEditor, EditorContent } from '@tiptap/react';
import { useAuth } from '../../contexts/AuthContext';
import { extensoesTiptap, paraExibicao } from './tiptapBase';

// Render somente-leitura do conteúdo Tiptap (mesmas extensões do editor pra abrir igual).
export default function RenderTiptap({ conteudo }) {
  const { token } = useAuth();
  const editor = useEditor({
    editable: false,
    extensions: extensoesTiptap,
    content: conteudo ? paraExibicao(conteudo, token) : '',
  });
  if (!editor) return null;
  return <EditorContent editor={editor} className="tt-content tt-content--render" />;
}
